import { gql } from '@apollo/client'

import { EVENT_FRAGMENT } from '../../../common/graphql/fragments'

import { LOCATION_TYPE_CATEGORY_NODE_FRAGMENT } from '../fragments'

const DELETE_LOCATION_TYPE_CATEGORY_MUTATION = gql`
  mutation deleteLocationTypeCategory($id: ID!) {
    deleteLocationTypeCategory(id: $id) {
      results {
        ...LocationTypeCategoryNodeFragment
      }
      latestEvent {
        ...EventFragment
      }
    }
  }
  ${EVENT_FRAGMENT}
  ${LOCATION_TYPE_CATEGORY_NODE_FRAGMENT}
`

export default DELETE_LOCATION_TYPE_CATEGORY_MUTATION
